import qs from 'qs';

const AccountAppVersion = {
    namespaced: true,

    state: {
        data: [],
    },

    getters: {
        data (state) {
            return state.data;
        },
    },

    mutations: {
        /**
         * Определить данные
         * @param state
         * @param items
         */
        setData (state, { items }) {
            state['data'] = items;
        },
    },


    actions: {
        /**
         * Получить данные о версиях приложений пользователей
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getData ({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                axios({
                    url: rootGetters.rootUrl + 'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.accountAppVersion,
                    }),
                }).then(response => (
                    commit('setData', { items: response.data }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные о версиях приложений пользователей получены.'),
                    resolve(response)
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true}),
                    console.log('ERROR IN accountAppVersion.js | getData: ' + err);
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при получении данных о версиях приложений пользователей!'),
                    reject(err);
                });
            })
        },
    },
};

export default AccountAppVersion;


// WEBPACK FOOTER //
// ./src/store/modules/accountAppVersion.js